import {compose} from "redux";
import withRedux from "../hoc/withRedux";
import App from "./App-redux";

export default compose(
    withRedux
)(App);
